import generateAction from '@piconetworks/pkg-generate-action';

var getSocialLinks = generateAction({
  baseActionCreatorName: 'getSocialLinks',
  baseActionTypeName: 'GET_SOCIAL_LINKS'
});
var createLink = generateAction({
  baseActionCreatorName: 'createLink',
  baseActionTypeName: 'CREATE_LINK'
});
var updateLink = generateAction({
  baseActionCreatorName: 'updateLink',
  baseActionTypeName: 'UPDATE_LINK'
});
var deleteLink = generateAction({
  baseActionCreatorName: 'deleteLink',
  baseActionTypeName: 'DELETE_LINK'
});
var types = [].concat(getSocialLinks.types, createLink.types, updateLink.types, deleteLink.types);
var creators = function creators(duck) {
  return Object.assign({}, getSocialLinks.creators(duck), createLink.creators(duck), updateLink.creators(duck), deleteLink.creators(duck));
};

export { creators, types };
//# sourceMappingURL=actions.js.map
